export const getToken = () => {
  return localStorage.getItem("access_token");
};

export const getUser = () => {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
};

export const isAuth = () => {
  return !!getToken();
};

export const isVendor = () =>{
  const user = getUser();
  return user?.roles_id === 3;
}

export const vendorStarted = () =>{
  const user = getUser();
  return user?.isvendor === 1;
}
